import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { IPImageSearchPatentApi, IPImageSearchPatentApiImpl } from '@/components/ai/plugins/image-search/services/apis/patent';
import { IPNewsletterApi, IPNewsletterApiImpl } from '@/components/ai/plugins/tech-newsletter/services/apis/newsletter';
import { MonitorFromWorkspaceApi, MonitorFromWorkspaceApiImpl } from '@/components/ai/plugins/tech-newsletter/services/apis/monitor-from-workspace';
import { IPImageFtoSearchApi } from './apis/image-fto-search-api';
import { IPImageFtoSearchApiImpl } from './apis/impls/image-fto-search-api';
import { IPatentLayoutApi } from './apis/patent-layout-api';
import { PatentLayoutApiImpl } from './apis/impls/patent-layout-api';
import { IPatentLinkApi } from './apis/patent-link-api';
import { PatentLinkApiImpl } from './apis/impls/patent-link-api';

export const ipServiceContainer = new ContainerModule(bind => {
    bind(IPImageSearchPatentApi).to(IPImageSearchPatentApiImpl);
    bind(IPNewsletterApi).to(IPNewsletterApiImpl);
    bind(MonitorFromWorkspaceApi).to(MonitorFromWorkspaceApiImpl);
    bind(IPImageFtoSearchApi).to(IPImageFtoSearchApiImpl);
    bind(IPatentLayoutApi).to(PatentLayoutApiImpl);
    bind(IPatentLinkApi).to(PatentLinkApiImpl);
});
